import './functions'

const page = document.body.dataset.page;

switch (page) {
    case 'select':
        Promise.all([
            import('./select'),
        ]);
        break;
    case 'play':
        Promise.all([
            import('./start'),
            import('./question'),
            import('./answer'),
            import('./ending')
        ]);
        break;
}